import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../css/press-release.css';


/* ── Sample data — replace with a real API call (e.g. getArticles({ category: 'press-release' })) ── */
const PRESS_RELEASES = [
  {
  _id: 'AI_Virtual',
  title:
    'AI Virtual — How Founder Hamid Kohan Helps Businesses Improve Productivity and Automate Daily Operations Through Artificial Intelligence',
  excerpt:
    'Hamid Kohan, founder of AI Virtual, is helping businesses explore the potential of artificial intelligence to improve productivity, streamline workflows, and automate daily operations. Through AI-driven solutions, AI Virtual focuses on helping organizations work more efficiently and adapt to the evolving digital business landscape.',
  author: 'Hamid Kohan',
  date: 'November 2, 2026',
  imageUrl:
    'https://xenogeneic-turquoise-isfetp2h.edgeone.dev/Hamid%20kohan%20artical.png',
},
  {
  _id: 'Jennifer_White',
  title:
    'Jennifer White — The Most Influential Healthcare Advocate & Author to Watch in 2026',
  excerpt:
    'Jennifer White, a healthcare advocate, author, former healthcare leader, and medical thriller writer, is making a meaningful impact through her dedication to healthcare advocacy, storytelling, and raising awareness of important healthcare issues.',
  author: 'Jennifer White',
  date: 'October 2, 2026',
  imageUrl:
    'https://architectural-amber-bycffsc3.edgeone.dev/MueyxfnCSE.png',
},
{
  _id: 'Dana_Hatch',
  title: 'Dana Hatch — Founder of The Unfiltered Method',
  excerpt:
    'Dana Hatch, founder of The Unfiltered Method, is redefining leadership through authenticity, human connection, and a more honest approach to personal and professional growth.',
  author: 'Dana Hatch',
  date: 'September 4, 2026',
  imageUrl:
    'https://ordinary-amber-smigi1lm.edgeone.dev/file.png',
},
  {
    _id: 'pr1',
    title: 'XTEND Reality Expansion Ltd. and JFB Construction Holdings Complete Business Combination, Raising $110 Million in Total Capital',
    excerpt:
      'The combined company completed its business combination and began trading on the NYSE under the ticker symbol XTND, marking a major step in its expansion of autonomous robotics and physical AI.',
    author: 'Editorial Team',
    date: 'September 4, 2026',
    imageUrl:
      'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=600&h=340&fit=crop&q=80',
  },

  // {
  //   _id: 'pr2',
  //   title: 'Kaseya Connect Edge Showcases the Future of IT, Cybersecurity and AI',
  //   excerpt:
  //     'Kaseya highlighted new developments in AI-powered cybersecurity, IT management, compliance, automation and operational efficiency during its global virtual innovation summit.',
  //   author: 'Editorial Team',
  //   date: 'September 2, 2026',
  //   imageUrl:
  //     'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=600&h=340&fit=crop&q=80',
  // },

  // {
  //   _id: 'pr3',
  //   title: 'CrowdStrike Unveils the Next Evolution of the Agentic SOC',
  //   excerpt:
  //     'CrowdStrike announced new multi-agent security capabilities designed to coordinate investigations across endpoint, identity, SaaS, cloud and network environments at machine speed.',
  //   author: 'Editorial Team',
  //   date: 'September 2, 2026',
  //   imageUrl:
  //     'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=600&h=340&fit=crop&q=80',
  // },

  // {
  //   _id: 'pr4',
  //   title: 'HPE and Oracle Deepen Networking Collaboration to Accelerate Gigawatt-Scale AI Infrastructure',
  //   excerpt:
  //     'HPE and Oracle announced an expanded collaboration focused on networking technologies and infrastructure designed to support the growing requirements of large-scale AI deployments.',
  //   author: 'Editorial Team',
  //   date: 'September 2, 2026',
  //   imageUrl:
  //     'https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&h=340&fit=crop&q=80',
  // },

  // {
  //   _id: 'pr5',
  //   title: 'Bel Announces Richard E. Hamilton as Senior Vice President, General Counsel and Corporate Secretary',
  //   excerpt:
  //     'Bel Fuse announced the appointment of Richard E. Hamilton to a senior leadership role, strengthening the company’s legal, governance and corporate leadership structure.',
  //   author: 'Editorial Team',
  //   date: 'September 4, 2026',
  //   imageUrl:
  //     'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=600&h=340&fit=crop&q=80',
  // },

  // {
  //   _id: 'pr6',
  //   title: 'AI PowerPoint Maker Presentations.ai Reaches 12 Million Users in 2026',
  //   excerpt:
  //     'Presentations.ai reported reaching 12 million users as demand grows for AI-powered presentation tools used for sales decks, investor presentations and board-level communications.',
  //   author: 'Editorial Team',
  //   date: 'September 4, 2026',
  //   imageUrl:
  //     'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=340&fit=crop&q=80',
  // },
];

const RECENT_POSTS = [
  {
    _id: 'r1',
    title: 'XTEND and JFB Construction Complete $110 Million Business Combination',
    date: 'September 4, 2026',
    imageUrl:
      'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=100&h=100&fit=crop&q=80',
  },

  {
    _id: 'r2',
    title: 'Presentations.ai Reaches 12 Million Users as AI Transforms Business Presentations',
    date: 'September 4, 2026',
    imageUrl:
      'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=100&h=100&fit=crop&q=80',
  },

  {
    _id: 'r3',
    title: 'CrowdStrike Advances Agentic AI for the Next Generation of Cybersecurity',
    date: 'September 2, 2026',
    imageUrl:
      'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=100&h=100&fit=crop&q=80',
  },

  {
    _id: 'r4',
    title: 'HPE Expands AI Infrastructure Collaboration to Support Gigawatt-Scale Computing',
    date: 'September 2, 2026',
    imageUrl:
      'https://images.unsplash.com/photo-1518770660439-4636190af475?w=100&h=100&fit=crop&q=80',
  },
];

const SOCIALS = [
  {
    label: 'Facebook',
    href: '#',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
        <path d="M13.5 21v-8h2.7l.4-3h-3.1V8.1c0-.9.3-1.6 1.6-1.6h1.7V3.8c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.5-4 4.1V10H8v3h2.4v8h3.1z" />
      </svg>
    ),
  },

  {
    label: 'X',
    href: '#',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
        <path d="M18.244 2H21.5l-7.11 8.13L22.75 22h-6.59l-5.16-6.74L5.1 22H1.84l7.6-8.69L1.25 2h6.76l4.66 6.16L18.244 2zm-1.15 17.8h1.8L6.98 4.08H5.05L17.094 19.8z" />
      </svg>
    ),
  },

  {
    label: 'Instagram',
    href: '#',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
        <path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.72 3.72 0 0 1-1.38-.9 3.72 3.72 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41 1.27-.06 1.65-.07 4.85-.07M12 0C8.74 0 8.33.01 7.05.07c-1.28.06-2.15.26-2.91.56a5.9 5.9 0 0 0-2.13 1.39A5.9 5.9 0 0 0 .62 4.15c-.3.76-.5 1.63-.56 2.91C0 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.28.26 2.15.56 2.91.31.79.72 1.46 1.39 2.13.67.67 1.34 1.08 2.13 1.39.76.3 1.63.5 2.91.56C8.33 24 8.74 24 12 24s3.67-.01 4.95-.07c1.28-.06 2.15-.26 2.91-.56a5.9 5.9 0 0 0 2.13-1.39 5.9 5.9 0 0 0 1.39-2.13c.3-.76.5-1.63.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.28-.26-2.15-.56-2.91a5.9 5.9 0 0 0-1.39-2.13A5.9 5.9 0 0 0 19.86.63c-.76-.3-1.63-.5-2.91-.56C15.67.01 15.26 0 12 0zm0 5.84A6.16 6.16 0 1 0 12 18.16 6.16 6.16 0 0 0 12 5.84zm0 10.16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.41-10.4a1.44 1.44 0 1 1-2.88 0 1.44 1.44 0 0 1 2.88 0z"/>
      </svg>
    ),
  },

  {
    label: 'LinkedIn',
    href: '#',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
        <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.13 1.44-2.13 2.94v5.67H9.35V8.99h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.61 0 4.28 2.38 4.28 5.48v6.27zM5.34 7.43a2.07 2.07 0 1 1 0-4.14 2.07 2.07 0 0 1 0 4.14zM3.56 20.45h3.56V8.99H3.56v11.46zM22.22 0H1.78C.8 0 0 .8 0 1.78v20.44C0 23.2.8 24 1.78 24h20.44c.98 0 1.78-.8 1.78-1.78V1.78C24 .8 23.2 0 22.22 0z" />
      </svg>
    ),
  },
];

const PAGE_SIZE = 4;

export default function PressReleasePage() {
  const [page, setPage] = useState(1);
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const totalPages = Math.max(1, Math.ceil(PRESS_RELEASES.length / PAGE_SIZE));
  const visible = PRESS_RELEASES.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const goToPage = (p) => {
    setPage(p);
    document.getElementById('pr-top')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubscribed(true);
    setEmail('');
  };

  return (
    <main className="pr-page" id="pr-top">
      <div className="wrap">
        {/* Breadcrumb */}
        <nav className="pr-breadcrumb" aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          <span className="pr-crumb-sep">»</span>
          <span className="pr-crumb-current">Press Release</span>
        </nav>

        <h1 className="pr-heading">Press Release</h1>

        <div className="pr-layout">
          {/* ── Main grid ── */}
          <div className="pr-main">
            <div className="pr-grid">
              {visible.map((item) => (
                <Link className="pr-card" to={`/article/${item._id}`} key={item._id}>
                  <div className="pr-card-img">
                    <img src={item.imageUrl} alt={item.title} loading="lazy" />
                  </div>
                  <div className="pr-card-body">
                    <h2 className="pr-card-title">{item.title}</h2>
                    <div className="pr-card-meta">
                      <span>By {item.author}</span>
                      <span className="pr-meta-sep">•</span>
                      <span>{item.date}</span>
                    </div>
                    <p className="pr-card-excerpt">{item.excerpt}</p>
                  </div>
                </Link>
              ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <nav className="pr-pagination" aria-label="Press release pages">
                {Array.from({ length: totalPages }).map((_, i) => (
                  <button
                    key={i}
                    className={`pr-page-btn ${page === i + 1 ? 'is-active' : ''}`}
                    onClick={() => goToPage(i + 1)}
                    aria-current={page === i + 1 ? 'page' : undefined}
                  >
                    {i + 1}
                  </button>
                ))}
                {page < totalPages && (
                  <button className="pr-page-btn pr-page-next" onClick={() => goToPage(page + 1)}>
                    Next &#8250;
                  </button>
                )}
              </nav>
            )}
          </div>

          {/* ── Sidebar ── */}
          <aside className="pr-sidebar">
            <div className="pr-widget">
              <h4 className="pr-widget-title">Stay In Touch</h4>
              <div className="pr-social-grid">
                {SOCIALS.map((s) => (
                  <a key={s.label} href={s.href} className="pr-social-btn" target="_blank" rel="noopener noreferrer">
                    <span className="pr-social-icon">{s.icon}</span>
                    <span>{s.label}</span>
                  </a>
                ))}
              </div>
            </div>

            {/* <div className="pr-widget">
              <h4 className="pr-widget-title">Recent</h4>
              <ul className="pr-recent-list">
                {RECENT_POSTS.map((p) => (
                  <li key={p._id}>
                    <Link to={`/article/${p._id}`}>
                      <img src={p.imageUrl} alt={p.title} loading="lazy" />
                      <div>
                        <span className="pr-recent-title">{p.title}</span>
                        <span className="pr-recent-date">{p.date}</span>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div> */}

            <div className="pr-widget pr-newsletter">
              <h4 className="pr-widget-title">Subscribe to Updates</h4>
              <p>Get the latest creative news and press releases delivered to your inbox.</p>
              {subscribed ? (
                <p className="pr-newsletter-success">Thanks — you're subscribed!</p>
              ) : (
                <form action="https://api.web3forms.com/submit" method="POST" className="pr-newsletter-form" onSubmit={handleSubscribe}>
                  <input type="hidden" name="access_key" value="5bd1a50d-901d-48a6-ba74-116fa5dbbe25"></input>
                  <input
                    type="email"
                    placeholder="Your email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <button type="submit">Subscribe</button>
                </form>
              )}
            </div>
          </aside>
        </div>
      </div>
    </main>
  );
}